import { render, staticRenderFns } from "./forms-table.vue?vue&type=template&id=1fc3b5b5&scoped=true"
import script from "./forms-table.vue?vue&type=script&lang=ts"
export * from "./forms-table.vue?vue&type=script&lang=ts"
import style0 from "./forms-table.vue?vue&type=style&index=0&id=1fc3b5b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc3b5b5",
  null
  
)

export default component.exports